export default __webpack_public_path__ + "static/media/phone-page-catchy.3fc06d08.jpg";